import qs from 'qs';

export const extendSearchPath = (location, searchPath = {}) => {
    const current = qs.parse(location.search, { ignoreQueryPrefix: true });

    return `${location.pathname}${qs.stringify({ ...current, ...searchPath }, { addQueryPrefix: true, strictNullHandling: true })}`;
}
